import ViewReport from "./ViewReport";

export default ViewReport;
